(function () {
  const SELECTOR = '.related-products.js-pdp-ymal .related-products-wrapper';
  const INITIALIZED_ATTRIBUTE = 'data-pdp-mobile-refinement';
  const MOBILE_QUERY = window.matchMedia('(max-width: 767px)');
  const MOBILE_SLICK_CONFIG = {
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    variableWidth: true,
  };
  const DEFAULT_SLICK_CONFIG = {
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  function setupRelatedProducts() {
    if (typeof window.jQuery === 'undefined') return;

    const $wrapper = window.jQuery(SELECTOR);
    if (!$wrapper.length || !$wrapper.find('.slide__product').length) return;

    if (!MOBILE_QUERY.matches) {
      if ($wrapper.attr(INITIALIZED_ATTRIBUTE) === 'true') {
        if ($wrapper.hasClass('slick-initialized')) {
          $wrapper.slick('unslick');
        }
        $wrapper.slick(DEFAULT_SLICK_CONFIG);
        $wrapper.removeAttr(INITIALIZED_ATTRIBUTE);
      }
      return;
    }

    if ($wrapper.attr(INITIALIZED_ATTRIBUTE) === 'true' && $wrapper.hasClass('slick-initialized')) return;

    if ($wrapper.hasClass('slick-initialized')) {
      $wrapper.slick('unslick');
    }

    $wrapper.slick(MOBILE_SLICK_CONFIG);
    $wrapper.attr(INITIALIZED_ATTRIBUTE, 'true');
  }

  function watchRelatedProducts() {
    const section = document.querySelector('.related-products.js-pdp-ymal');
    if (!section) return;

    const observer = new MutationObserver(function () {
      const wrapper = section.querySelector('.related-products-wrapper');
      if (
        wrapper &&
        wrapper.classList.contains('slick-initialized') &&
        wrapper.getAttribute(INITIALIZED_ATTRIBUTE) !== 'true' &&
        wrapper.querySelector('.slide__product')
      ) {
        setupRelatedProducts();
      }
    });

    observer.observe(section, { attributes: true, childList: true, subtree: true });
    MOBILE_QUERY.addEventListener('change', setupRelatedProducts);
    setupRelatedProducts();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchRelatedProducts);
  } else {
    watchRelatedProducts();
  }
})();
